import React, { useState, useEffect, useRef } from "react";
import "../../assets/css/new-website.css"
import Footer from "../layout/footerUpdated";
import Header from "../layout/headerHome";
import FAQComponent from '../element/component/faq';
import TestimonialSlider from "../element/component/testimonial-slider";
import { Helmet } from "react-helmet";
import WhyAudio from '../element/component/why-audio';
import Popup_Main from "../element/component/Popup_Main";
import ReachToUsForm from "../element/ReachToUsForm";


const AHC = () => {

  const [isOpen, setIsOpen] = useState(false);

const [activeIndex, setActiveIndex] = useState(0);
  
const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
 };

const hearingSigns = [
  {
    title: "Difficulty Following Conversations",
    icon: "/images/new-website/audiometry/hearing-conversation.webp",
  },
  {
    title: "Frequently Asking People to Repeat",
    icon: "/images/new-website/audiometry/hearing-repeat.webp",
  },
  {
    title: "Increasing TV or Phone Volume",
    icon: "/images/new-website/audiometry/hearing-volume.webp",
  },
  {
    title: "Changes in One or Both Ears",
    icon: "/images/new-website/audiometry/hearing-ear.webp",
  },
  {
    title: "Hearing Changes With Age",
    icon: "/images/new-website/audiometry/hearing-age.webp",
  },
  {
    title: "Balance or Dizziness Concerns",
    icon: "/images/new-website/audiometry/hearing-balance.webp",
  },
];



const whyData = [
    { title: "World-Class Hearing Aids, Trusted Global Brands", desc: "We offer premium devices from the most respected names in hearing care.", image: "/images/new-website/audiometry/hearing-aid (1).webp" },
    { title: "State-of-the-Art Technology, Seamless Experience", desc: "Advanced equipment ensures accurate diagnosis and personalized solutions", image: "/images/new-website/home-new/healthcare-home.webp" },
    { title: "Precision Meets Compassion", desc: "High-tech tools combined with human warmth for a complete, personalized, and supportive hearing journey", image: "/images/new-website/home-new/elder-care-home.webp" },
    { title: "Hear the World Again—Emotionally and Clearly", desc:"We don’t just restore hearing; we reconnect you to people, places, and memories", image: "/images/new-website/audiometry/global.webp" },
    { title: "Global Quality, Local Trust", desc: "Access cutting-edge hearing aids from global brands, with expert fitting, ongoing support, and affordable plans", image: "/images/new-website/audiometry/global-quality.webp" },
    { title: "Beyond Devices—We Build Connections", desc: "Our goal isn’t just better hearing, but a better quality of life through emotional connection", image: "/images/new-website/home-new/women-care-home.webp" },
  ];


  const audioCareServices = [
    {
        name: "Pure Tone Audiometry (PTA)",
        desc: "",
        image: "/images/new-website/audiometry/pta-updated.webp",
      },
      {
        name: "Tympanometry Test",
        desc: "",
        image: "/images/new-website/audiometry/tympanometry-final.webp",
      },
      {
        name: "Oto Acoustic Emission (OAE)",
        desc: "",
        image: "/images/new-website/audiometry/OAE.webp",
      },
      {
        name: "Brainstem Evoked Response Audiometry (BERA)",
        desc: "",
        image: "/images/new-website/audiometry/bera-updated.webp",
      },
      {
        name: "Vestibular Evoked Myogenic Potentials (VEMPs)",
        desc: "",
        image: "/images/new-website/audiometry/vemp.webp",
      },
      {
        name: "Posturography",
        desc: "",
        image: "/images/new-website/audiometry/posturography-final.webp",
      },
      {
        name: "Videonystagmography (VNG)​",
        desc: "",
        image: "/images/new-website/audiometry/vng-final.webp",
      },
      {
        name: "Hearing Aid Dispensing and services",
        desc: "",
        image: "/images/new-website/audiometry/hearing-aid-new.webp",
      },
  ];

  const testimonials = [
    {
      content:
        "My mother had recently been diagnosed with hearing deficiencies, we got in touch with these guys mr Arvinda kept in touch with us and understood our concerns and gave us the best of the hearing equipment so far good me Aryan who came to our home was very friendly and knows how to work with senior citizens definitely recommending them.",
      name: "Adil Ustad",
      image: "/images/new-website/bridgehealth-icon-new.webp", // Replace with actual image URL
    },
    {
      content:
        "Shrayas services from time to time to the fitment my ear aids have been very satisfactory n very good. Balan ur customer",
      name: "Balan Swarna",
      image: "/images/new-website/bridgehealth-icon-new.webp", // Replace with actual image URL
    },
    {
      content:
        "Recently I bought a phonak hearing aid for my father. Service was good. Aravind/ Aryan came to test the device, delivered also. In case of issue also they come to fix it when I asked them to visit.. they did recalibration. Device is working fine. Thanks.",
      name: "Manish Kumar",
      image: "/images/new-website/bridgehealth-icon-new.webp", // Replace with actual image URL
    },
  ];


  const faqs = [
    {
      question: "What is a hearing assessment?",
      answer:
          "A hearing assessment evaluates how well you hear different sounds and may include more than one test depending on your symptoms and hearing needs.",
        },
    {
      question: "How do I know which hearing test I need?",
      answer: "You do not usually need to choose a test yourself. Your audiologist can recommend the appropriate assessment based on your symptoms, history and clinical requirements.",   },
    {
      question: "Is Tympanometry painful?",
      answer: "No. A small probe is placed in the ear canal while air pressure briefly changes to measure how the eardrum and middle ear are functioning.",
    },
    {
      question: "What is an OAE test?",
      answer: "OAE testing measures responses produced by the inner ear and can provide useful information about cochlear function.",
    },
    {
      question: "Does Bridge Health provide hearing aids?",
      answer: "Yes. Bridge Health lists hearing-aid dispensing and related hearing-care services at participating locations. ",
    },
    {
      question: "What tests are performed to diagnose vertigo?",
      answer: "Tests for vertigo include videonystagmography (VNG), audiometry, balance tests, and sometimes MRI or CT scans. These helps identify whether the cause is ear-related or neurological.",
    },
    {
      question: "Why do I frequently hear a ringing sound in my ears?",
      answer: "That ringing sound is known as tinnitus. It can be caused by hearing loss, loud noise exposure, or medical conditions. A hearing professional can help diagnose and manage it effectively.",
    },
];


  const [isMobile, setIsMobile] = useState(false);
  const sectionRefs = useRef([]); // Refs for multiple sections/cards
  const [hasAnimated, setHasAnimated] = useState([]); // Animation tracking for cards

  // Resize event listener to detect mobile view
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize(); // Initialize on mount
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Scroll Animation Logic
  useEffect(() => {
    const handleScroll = () => {
      const updatedVisibility = sectionRefs.current.map((ref) => {
        if (ref) {
          const rect = ref.getBoundingClientRect();
          const windowHeight =
            window.innerHeight || document.documentElement.clientHeight;

          // Element becomes visible when its top is within viewport
          return rect.top <= windowHeight - 50;
        }
        return false;
      });

      setHasAnimated((prev) =>
        updatedVisibility.map((visible, index) => prev[index] || visible)
      );
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // Trigger on mount to check initial visibility
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);



  return (
    <div>
      <Helmet>
        <title>AudioCare | Top Pathology Lab in Bangalore</title>
        <meta name="description" content="Book reliable NABL & CAP-accredited lab tests in Bangalore. Wide range of diagnostics with fast results. Home sample collection available. Schedule now!" />
        <meta name="keywords" content="Book blood test in bangalore | book blood tests at home | pathology lab | liver function test |lipid profile |kidney function test | diagnostic services |" />
        <meta name="author" content="Bridge Health" />
        <meta property="og:title" content="Best NABL & ISO Accredited Blood Test Services | Top Pathology Lab in Bangalore" />
        <meta property="og:description" content="Book reliable NABL & CAP-accredited lab tests in Bangalore. Wide range of diagnostics with fast results. Home sample collection available. Schedule now!" />
        <meta property="og:image" content="https://bridgehealth.in/images/new-website/radiology/lab-test-bg.webp" />
        <meta property="og:url" content="https://bridgehealth.in/lab-tests" />
        <meta name="robots" content="index, follow" />
      </Helmet>
      <Header/>
      <div className={`landingcontainerAudio ${isMobile ? "mobile" : ""}`}>
        <div className={`leftContainerAudio ${isMobile ? "mobile" : ""}`}>
          <h1 className="first-section-heading-audio">
          {" "}
            <span className="highlight1">Expert Hearing Care</span> for Clearer, More Confident Listening
          </h1>
          <p className="paragraph-left">From routine hearing assessments to advanced audiology tests and hearing-aid support, get personalised care to understand your hearing and determine the right next step.</p>
          <button className="buttonlanding" onClick={()=>setIsOpen(true)}>Book a Hearing Assessment</button>
        </div>
        <div className="rightContainerAudio">
          <img
            src="/images/new-website/audiometry/audiometry-landing.webp"
            alt="Woman smiling"
            className="imagelanding imageFadeInUp"
          />
        </div>
      </div>

    <section >
        <div className="check-hearing">
            <h2 className="heading1">
              When Should You Get Your
              <span className="highlight1"> Hearing Checked?</span>
              <span className="line-break-heading"></span>
            </h2>
            <p className="dental-text">Changes in hearing can happen gradually. A professional assessment can help identify what may be affecting your hearing and whether further evaluation is needed. </p>
        </div>
         <div className="hearing-signs-grid">
          {hearingSigns.map((item, index) => (
            <div className="hearing-sign-card" key={index}>

              <div className="hearing-sign-icon">
                <img
                  src={item.icon}
                  alt=""
                  loading="lazy"
                />
              </div>

              <div className="hearing-sign-content">
                <h3>{item.title}</h3>
              </div>

            </div>
          ))}
        </div>

    </section>

    <section>
            <div className="rightstrongcontainerlandingAHP">
              <h2 className="heading1">
              Explore Our Advanced 
                <span className="highlight1"> Audiology Tests</span>
              </h2>
              <p className="physio-text">Bridge Health's Hearing Care provides comprehensive hearing assessments, advanced audiology tests and hearing-aid support for people experiencing changes in hearing or balance.</p>
            <div className="yoga-type-card-section">
                {audioCareServices.map((yoga, index) => (
                    <div
                    key={index}
                    className="yoga-type-card-audio"
                    >
                    <img src={yoga.image} alt={yoga.name} className="leadership-image" />
                    <h3 className="solutiontext"><span>{yoga.name.split(" ")[0]}</span>{" "}
                    {yoga.name.split(" ").slice(1).join(" ")}</h3>
                    <p className="yoga-type-desc">{yoga.desc}</p>
                    </div>
                ))}
          </div>
              <div className="service-section-button-audio">
                <button className="buttonlanding" onClick={()=>setIsOpen(true)}>Book a Hearing Assessment</button>
              </div>
              </div>
    </section>

     <section >
        <div className="check-hearing">
            <h2 className="heading1">
              Explore Our Advanced 
              <span className="highlight1"> Audiology Tests</span>
              <span className="line-break-heading"></span>
            </h2>
            <p className="dental-text">When hearing aids are recommended, the right solution depends on more than your hearing test. Your listening environments, daily routine, comfort and communication needs all matter when selecting and fitting a device.</p>
        </div>
         <div className="hearing-signs-grid">
          {hearingSigns.map((item, index) => (
            <div className="hearing-sign-card" key={index}>

              <div className="hearing-sign-icon">
                <img
                  src={item.icon}
                  alt=""
                  loading="lazy"
                />
              </div>

              <div className="hearing-sign-content">
                <h3>{item.title}</h3>
              </div>

            </div>
          ))}
        </div>

    </section>


      <section className="why-choose-section-audio">
      <h2 className="heading1">
        Why Choose Bridge Health<span className="highlight-text"> for Hearing Care?</span>
      </h2>
      <WhyAudio
            whyData={whyData} 
            dynamicText="Radiology" 
            dynamicParagraph="We have some of the best specialists who bring years of experience and offer evidence – based treatment to ensure best care for you" 
          />
    </section>

    <section className="why-choose-section-audio-partner">
      <h2 className="heading1">
        Our<span className="highlight-text"> Partners</span>
      </h2>
      <div className="audioPartner">
          <img
            src="/images/new-website/audiometry/oticon.webp"
            alt="oticon"
          />
          <img
            src="/images/new-website/audiometry/resound.webp"
            alt="oticon"
          />
          <img
            src="/images/new-website/audiometry/phonak-logo.webp"
            alt="oticon"
          />
          <img
            src="/images/new-website/audiometry/signia.webp"
            alt="oticon"
          />
      </div>
    </section>

    <section>
        <div>
        <FAQComponent faqs={faqs} />
        </div>
    </section>

    <section>
    <div className="testimonials-container">
      {/* Left Side */}
      <div className="left-section-testimonial">
        <h2>
        Trust Us Based on What Our <span className="highlight1">Patrons Say</span>
        </h2>
        <h3>Overall Ratings</h3>
        <div className="ratings">
          <img
            src="/images/new-website/women-care/google-logo-1.webp"
            alt="Google Logo"
          />
          <div>
            <p>
              4.9{" "}
              <span className="stars">
                ⭐⭐⭐⭐⭐
              </span>
            </p>
            <p>Customer Reviews</p>
          </div>
        </div>
        <a href="https://www.google.com/search?q=bridgehealth&sca_esv=f8c3d57e75161cda&source=hp&ei=k3mQZ5CSHe_G1e8Psu7IkA4&iflsig=AL9hbdgAAAAAZ5CHoz7_cRGSTpek_a5zgM_qrQEKb84T&ved=0ahUKEwjQp-qYxIiLAxVvY_UHHTI3EuIQ4dUDCBk&uact=5&oq=bridgehealth&gs_lp=Egdnd3Mtd2l6IgxicmlkZ2VoZWFsdGgyCxAuGIAEGMcBGK8BMgUQABiABDIFEAAYgAQyBRAAGIAEMgUQABiABDIFEAAYgAQyBRAAGIAEMggQABiABBiiBDIIEAAYgAQYogQyCBAAGIAEGKIESNgdUABY_hpwAHgAkAEAmAHKAaABqg-qAQYwLjExLjG4AQPIAQD4AQGYAgygAuAPwgIIEAAYgAQYsQPCAgsQABiABBixAxiDAcICBRAuGIAEwgILEC4YgAQYsQMYgwHCAg4QLhiABBixAxiDARiKBcICDhAAGIAEGLEDGIMBGIoFwgIIEC4YgAQYsQPCAg4QLhiABBixAxjRAxjHAcICCxAAGIAEGLEDGIoFwgILEC4YgAQYsQMY1AKYAwCSBwYwLjExLjGgB86VAQ&sclient=gws-wiz#lrd=0x3bae1571e6b9bbaf:0xc485c6444a9e56b4,3,,,," target="_blank" rel="noopener noreferrer">
        <button className="buttonmaphome-review">Write a Review</button>
        </a>
      </div>

      {/* Right Side */}
      <div className="right-section-testimonial">
        <div className="testimonial-page">
      <TestimonialSlider testimonials={testimonials} />
    </div>
      </div>
    </div>
    </section>
    <Popup_Main isOpen={isOpen} onClose={() => setIsOpen(false)} >
        <ReachToUsForm submitted={() => setIsOpen(false)} />
        </Popup_Main>
        <Footer />
    </div>
  );
};

export default AHC;